
import Vue from "vue";
import Component from "vue-class-component";
import { MenuItem } from "../../models/MenuItem";
import { Prop } from "vue-property-decorator";

@Component
export default class ContextMenu extends Vue {
  @Prop({ default: [] })
  menuItems: MenuItem[];

  @Prop({ required: true })
  id: string;

  item: any = null;

  show(event, item) {
    this.item = item;
    var menu = document.getElementById(this.id);
    if (!menu) {
      return;
    }

    const menuWidth = menu.offsetWidth;
    const menuHeight = menu.offsetHeight;

    menu.style.visibility = "hidden";
    menu.style.display = "block";
    menu.removeAttribute("style");

    if (menuWidth + event.pageX >= window.innerWidth) {
      menu.style.left = `${event.pageX - menuWidth + 2}px`;
    } else {
      menu.style.left = `${event.pageX - 2}px`;
    }

    if (menuHeight + event.pageY >= window.innerHeight) {
      menu.style.top = `${event.pageY - menuHeight + 2}px`;
    } else {
      menu.style.top = `${event.pageY - 2}px`;
    }

    menu.classList.add("context-menu--active");
  }

  itemClicked(menuItem: MenuItem) {
    if (menuItem.action) menuItem.action(this.item);

    this.$emit("click", menuItem);
    this.hide();
  }

  hide() {
    var menu = document.getElementById(this.id);
    if (!menu) {
      return;
    }

    menu.classList.remove("context-menu--active");
    this.$emit("hidden");
  }

  get validMenuItems() {
    return this.menuItems.filter(x => x.isValid === undefined || x.isValid(this.item));
  }
}
